// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".canvas-area[data-v-b7c72b18] {\n  position: absolute;\n  transform-origin: left top;\n  box-sizing: content-box;\n  border-style: solid;\n  border-color: #f4f4fb;\n}\n.canvas-area .background[data-v-b7c72b18] {\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n.canvas-area .background img[data-v-b7c72b18] {\n      position: absolute;\n}\n", ""]);
// Exports
module.exports = exports;
